import moment from 'moment';

export const isEmptyObj = (obj) => JSON.stringify(obj) === '{}';

export const isFirefox = () => navigator.userAgent.search(/Firefox/) > 0;

export const isIE = () =>
    navigator.userAgent.search(/MSIE/) > 0 ||
    navigator.userAgent.search(/NET CLR /) > 0 ||
    (!!window.MSInputMethodContext && !!document.documentMode);

export const isSafari = () => /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const trimStringNicely = (str, maxLength) => {
    if (str.length < maxLength || str.length === maxLength) {
        return str;
    }
    const slicedString = str.slice(0, maxLength);
    const firstSpaceFromEndPosition = slicedString.lastIndexOf(' '); // ищем индекс первого пробела с конца

    const trimmedString = str.slice(0, firstSpaceFromEndPosition); // режем до пробела

    const symbolBeforeSpace = trimmedString.charAt(firstSpaceFromEndPosition - 1); // берем символ перед пробелом

    const isSeparator = symbolBeforeSpace.search(/[^\d\sA-Z\sa-z\sА-Я\sа-я]/gi) !== -1; // проверка на символы не являющиеся буквами/цифрами/пробелами

    const isTagQuote = symbolBeforeSpace.search(/>|</gi) !== -1; // проверка на кавычки от тэгов подсветки тэгов <em></em>

    if (isTagQuote) {
        return `${trimmedString} ...`;
    }
    if (isSeparator) {
        return `${trimmedString.slice(0, firstSpaceFromEndPosition - 1)} ...`;
    }
    return `${trimmedString} ...`;
};

export const trimString = (str) => {
    const firstSpaceFromEndPosition = str.lastIndexOf(' '); // ищем индекс первого пробела с конца
    const trimmedString = str.slice(0, firstSpaceFromEndPosition); // режем до пробела

    const symbolBeforeSpace = trimmedString.charAt(firstSpaceFromEndPosition - 1); // берем символ перед пробелом

    const isSeparator = symbolBeforeSpace.search(/[^\d\sA-Z\sa-z\sА-Я\sа-я]/gi) !== -1; // проверка на символы не являющиеся буквами/цифрами/пробелами

    const isTagQuote = symbolBeforeSpace.search(/>|</gi) !== -1; // проверка на кавычки от тэгов подсветки тэгов <em></em>

    if (isTagQuote) {
        return `${trimmedString} ...`;
    }
    if (isSeparator) {
        return `${trimmedString.slice(0, firstSpaceFromEndPosition - 1)} ...`;
    }
    return `${trimmedString} ...`;
};

export const compareFormat = 'YYYY-MM-DD';

export const validateDates = (startDate, endDate) => {
    // Приводим к специальному формату для сравнения, в других форматах moment почему-то не сравнивает
    const startDateFormatted = startDate ? moment(startDate).format(compareFormat) : null;
    const endDateFormatted = endDate ? moment(endDate).format(compareFormat) : null;
    const todayDateFormatted = moment().format(compareFormat);

    const isEndDateAfterStartDate = endDate ? moment(endDateFormatted).isAfter(startDateFormatted) : true;
    const isEndDateBeforeToday = endDate ? moment(endDateFormatted).isBefore(todayDateFormatted) : true;
    const isEndDateSameToday = endDate ? moment(endDateFormatted).isSame(todayDateFormatted) : true;
    const isEndDateNotAfterToday = endDate ? !moment(endDateFormatted).isAfter(todayDateFormatted) : false;

    // Проверка даты на валидность в целом, чтоб не проскакивали даты вроде 35.09.20
    const isStartDateValid = startDate ? moment(startDate, compareFormat).isValid() : false;
    const isEndDateValid = endDate ? moment(endDate, compareFormat).isValid() : false;
    const isSameDates = startDate && endDate ? moment(startDateFormatted).isSame(endDateFormatted) : false;

    const isValidEndDateEdge = (isEndDateBeforeToday || isEndDateSameToday) && isEndDateNotAfterToday;

    const isValidDatesOrder = (isEndDateAfterStartDate && isValidEndDateEdge) || isSameDates;

    if (isStartDateValid && isEndDateValid && isValidDatesOrder) {
        return true;
    }
    return false;
};

// эта функция используется только для вычисления того, истёк токен юзера или нет
export function checkUserExpirationDateExpired(expirationDate) {
    if (expirationDate) {
        const compareFormat = 'YYYY-MM-DD';
        const todayFormatted = moment().format(compareFormat);
        const expirationDateFormatted = moment(expirationDate).format(compareFormat);
        return moment(todayFormatted).isSame(expirationDateFormatted, 'day');
    }
    return true;
}



// WEBPACK FOOTER //
// ./src/utils/helpers.js